import store from './store';
import auth from './auth';

interface IConfig {
  codeEnv: string;
  loginTitle?: string;
}

const easyLogin = {
  // 初始化s
  init(config: IConfig) {
    Object.assign(store, config);
    this.setLoginUrl(config.codeEnv);
  },
  setLoginUrl(codeEnv?: string) {
    const url = `https://m.hellobike.com/AppHelloEasyLoginH5/${
      !codeEnv || codeEnv === 'pro' ? '' : `${codeEnv}/`
    }latest/index.html#/login`;
    store.loginUrl = url;
  },

  // 登录
  signIn(config: IConfig) {
    this.init(config);
    auth.checkLoginStatus();
  },

  // 登出
  signOut() {},
};

export default easyLogin;
